import HubLayout from './HubLayout';
import { useCategories } from '../hooks/useCategories';

export default function DavetiyelerHub() {
  const { categories, loading } = useCategories('davetiyeler');

  if (loading) {
    return (
      <main className="page hub-page">
        <p className="section-note" style={{ padding: '2rem 1rem' }}>Yükleniyor…</p>
      </main>
    );
  }

  return (
    <HubLayout
      title="Davetiye çeşitleri"
      subtitle="Eskişehir’de ekonomik davetiye, sade davetiye ve lüks davetiye modelleri — düğün, sünnet ve nişan koleksiyonları."
      categories={categories}
      basePath="/davetiyeler"
    />
  );
}
